<template>
  <div class="body-nav">
    <ul class="nav-tabs side-nav cf">
      <li :class="{ active: $route.path === '/company' }">
        <Link :to="'/company/'">
          <span class="material-icons">dashboard</span>
          <span>{{ $t('meta.overview') }}</span>
        </Link>
      </li>
      <li :class="{ active: $route.path === '/company/projects' }">
        <Link :to="'/company/projects'">
          <span class="material-icons">all_inbox</span>
          <span>{{ $t('meta.projects') }}</span>
        </Link>
      </li>
      <li v-if="companyUser.company_type === 'industry'" :class="{ active: $route.path === '/company/sites' }">
        <Link :to="'/company/sites'">
          <span class="material-icons">domain</span>
          <span>{{ $t('meta.sites') }}</span>
        </Link>
      </li>
      <li v-if="displayCostCenters" :class="{ active: $route.path === '/company/cost_centers' }">
        <Link :to="'/company/cost_centers'">
          <span class="material-icons">receipt_long</span>
          <span>{{ $t('meta.costCenters') }}</span>
        </Link>
      </li>
      <li :class="{ active: $route.path === '/company/containers' }">
        <Link :to="'/company/containers'">
          <span class="material-icons">delete</span>
          <span>{{ $t('meta.containers') }}</span>
        </Link>
      </li>
      <li v-if="companyUser.company_type === 'branch'" :class="{ active: $route.path === '/company/container_groups' }">
        <Link :to="'/company/container_groups'">
          <span class="material-icons">share_location</span>
          <span>{{ $t('nav.containerGroups') }}</span>
        </Link>
      </li>
      <li :class="{ active: $route.path === '/company/sensors' }">
        <Link :to="'/company/sensors'">
          <span class="material-icons">wifi_tethering</span>
          <span>{{ $t('meta.sensors') }}</span>
        </Link>
      </li>
      <li :class="{ active: $route.path === '/company/vehicles' }">
        <Link :to="'/company/vehicles'">
          <span class="material-icons">local_shipping</span>
          <span>{{ $t('meta.vehicles') }}</span>
        </Link>
      </li>
      <li :class="{ active: $route.path === '/company/routes' }">
        <Link v-if="companyUser.company_type === 'branch'" :to="'/company/routes'">
          <span class="material-icons">map</span>
          <span>{{ $t('meta.routes') }}</span>
        </Link>
      </li>
      <li :class="{ active: $route.path === '/company/fractions' }">
        <Link :to="'/company/fractions'">
          <span class="material-icons">info</span>
          <span>{{ $t('meta.fractions') }}</span>
        </Link>
      </li>
      <li v-if="companyUser.company.unicorn_client" :class="{ active: $route.path === '/company/weigh_stations' }">
        <Link :to="`/company/weigh_stations`">
          <span class="material-icons">scale</span>
          <span>{{ $t('meta.weighStations') }}</span>
        </Link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  inject: ['companyUser'],
  computed: {
    displayCostCenters() {
      if (this.companyUser.company_type === 'industry') {
        if (this.companyUser.user.admin) return true
        if (this.companyUser.roles.includes('company_admin')) return true
      }

      return false
    },
  },
}
</script>
